module.exports = __webpack_public_path__ + "static/10-011462370ea5d7d6d856aca13a16fe74.png";